import React from 'react';
import { TopBanner } from './components/TopBanner';
import { Hero } from './components/Hero';
import { Section1 } from './components/Section1';
import { Section2 } from './components/Section2';
import { Section3 } from './components/Section3';
import { Section4 } from './components/Section4';
import { Section5 } from './components/Section5';
import { Section6 } from './components/Section6';
import { Section7 } from './components/Section7';
import { Section8 } from './components/Section8';
import { Section9 } from './components/Section9';
import { Section10 } from './components/Section10';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <TopBanner data-id="element-1" />
      <Hero data-id="element-2" />
      <Section1 data-id="element-3" />
      <Section2 data-id="element-4" />
      <Section3 data-id="element-5" />
      <Section4 data-id="element-6" />
      <Section5 data-id="element-7" />
      <Section6 data-id="element-8" />
      <Section7 data-id="element-9" />
      <Section8 data-id="element-10" />
      <Section9 data-id="element-11" />
      <Section10 data-id="element-12" />
    </div>;
}